import { render } from "./ErrorPaymentInfo.vue?vue&type=template&id=168e1301&scoped=true"
import script from "./ErrorPaymentInfo.vue?vue&type=script&lang=js"
export * from "./ErrorPaymentInfo.vue?vue&type=script&lang=js"

import "./ErrorPaymentInfo.vue?vue&type=style&index=0&id=168e1301&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168e1301"]])

export default __exports__